import React from 'react';
import { Grid, Header, Icon } from 'semantic-ui-react';

const NotFoundPage = () => {
  return (
    <Grid textAlign="center">
      <Grid.Column>
        <Header as="h2" icon>
          <Icon name="street view" />
          Feeling Lost?
          <Header.Subheader>No worries, we are lost too.</Header.Subheader>
        </Header>
      </Grid.Column>
    </Grid>
  );
};

export default NotFoundPage;
